import {Component, computed, input} from '@angular/core';
import {DateValue, formatDisplayDateTime} from './date-format';

/**
 * Every date/time the UI shows: `<app-date [value]="file.last_modified" />`. Monospace, as the
 * date convention asks; zone and layout come from date-format.ts.
 */
@Component({
  selector: 'app-date',
  template: `<span class="cl-font-monospace">{{ text() }}</span>`,
  // A date never wraps. Its longest form ("05 Sep 2026 23:58") is 158px in castlabs-ui's DM Mono;
  // fixed date columns are 200px to fit it plus the 16px cell padding.
  styles: `:host { white-space: nowrap; }`,
})
export class DateComponent {
  readonly value = input<DateValue>(null);
  /** What to show when there is no date (e.g. '—'). */
  readonly empty = input('');
  readonly text = computed(() => formatDisplayDateTime(this.value()) || this.empty());
}
